<div class="action-button-wrapper">
  <ion-button
    class="action-button"
    (click)="clickAddItem()"
    [fill]="buttonFill"
  >
    <ion-icon slot="start" class="icon" [src]="src" [alt]="alt"> </ion-icon>
    <div slot="end" class="button-text">
      {{ buttonText }}
    </div>
  </ion-button>
</div>
